import { Component } from "react";
import { connect } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { exibeModal } from "../../actions/ModalActions";

class ModalExample extends Component {
  constructor(props) {
    super(props);
  }

  toggle = () => {
    this.props.exibeModal(!this.props.isOpen);

    if (this.props.close) {
      this.props.close();
    }
  };

  render() {
    return (
      <div>
        {/* <Button color="danger" onClick={this.toggle}>{this.props.buttonLabel}</Button> */}
        <Modal
          id={this.props.id}
          isOpen={this.props.isOpen}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader
            className={this.props.classCssHeader}
            toggle={this.toggle}
          >
            {this.props.title}
          </ModalHeader>
          <ModalBody>{this.props.children}</ModalBody>
          <ModalFooter>
            {this.props.textBtnCancel !== undefined ? (
              <Button color="primary" onClick={this.props.clickBtnCancel}>
                {this.props.textBtnCancel}
              </Button>
            ) : (
              ""
            )}

            {this.props.textBtnOk !== undefined ? (
              <Button color="secondary" onClick={this.props.clickBtnOk}>
                {this.props.textBtnOk}
              </Button>
            ) : (
              ""
            )}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.modal.isOpen,
  };
};

export default connect(mapStateToProps, { exibeModal })(ModalExample);
